import React, { useEffect, useRef } from 'react';

const PopoverMenuWrapper = ({ open = false, ...props }) => {
  return open ? <PopoverMenu {...props} /> : null;
};

const PopoverMenu = ({ anchorElement, offsetMargin = 8, position = 'bottom', children, onClose, style: overwriteStyle = {} }) => {
  const popoverRef = useRef(null);
  const { width, left, top, height } = anchorElement.getBoundingClientRect();
  const fixedTop = top + window.scrollY;
  let positionStyle = {};

  switch (position) {
    case 'bottom':
      positionStyle = {
        left: left + width / 2,
        top: fixedTop + height - offsetMargin,
        transform: 'translateX(-50%)',
      };
      break;
    case 'top':
      positionStyle = {
        left: left + width / 2,
        top: fixedTop + offsetMargin,
        transform: 'translate(-50%, -100%)',
      };
      break;
    case 'left':
      positionStyle = {
        left: left + offsetMargin,
        top: fixedTop + height / 2,
        transform: 'translate(-100%, -50%)',
      };
      break;
    case 'right':
      positionStyle = {
        right: left + offsetMargin,
        top: fixedTop + height / 2,
        transform: 'translate(100%, -50%)',
      };
      break;
  }

  useEffect(() => {
    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, []);


  const handleClick = (e) => {
    if (anchorElement?.contains(e.target)) return;
    if (popoverRef?.current?.contains(e.target)) return;
    onClose();
  };

  return (
    <div
      ref={popoverRef}
      style={{
        ...styles.wrapper,
        ...positionStyle,
        ...overwriteStyle,
      }}
    >
      {children.map((child, i) => {
        return (
          <div key={i}>
            {React.cloneElement( child, { onClose } )}
            {i !== children.length - 1 ? <hr style={styles.divider} /> : null}
          </div>
        );
      })}
    </div>
  );
};

const styles = {
  wrapper: {
    position: 'absolute',
    zIndex: 999999,
    boxShadow: '0px 0px 24px rgba(0, 0, 0, 0.06), 0px 0px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
  },
  divider: {
    margin: '0px 16px',
    border: 'none',
    height: 1,
    backgroundColor: '#C4C4C4',
  },
};

export default PopoverMenuWrapper;
